module.exports = __webpack_public_path__ + "img/pprof_svg_getting_started.69b0e2e8.png";